const React = require('react');
const FormConfig = require('./formConfig');
const FormValueUtils = require('hooks/useFormPrimitives/value');
const SelectWithSpecifyUtils = require('hooks/useFormPrimitives/selectWithSpecifyUtils');
const { buildValidationFieldNames } = require('hooks/useFormPrimitives/validation');

const {
    useCallback,
    useMemo
} = React;

const internals = {};

internals.FINAL_SUBMIT_OMIT_FIELD_NAMES = new Set([
    'picFile',
    'picPreviewURL',
    'cropPosition',
    'cropRotation',
    'cropScale'
]);

internals.omitFinalSubmitOnlyFields = (details = {}) => Object.entries(details)
    .reduce((collector, [fieldName, value]) => {

        if (!internals.FINAL_SUBMIT_OMIT_FIELD_NAMES.has(fieldName)) {
            collector[fieldName] = value;
        }

        return collector;
    }, {});

internals.normalizeSignupDetails = ({
    details = {},
    formConfig
}) => {

    return Object.entries(details).reduce((collector, [fieldName, value]) => {
        const definition = formConfig.getFieldDefinition?.(fieldName);

        collector[fieldName] = definition?.type === 'selectWithSpecify'
            ? SelectWithSpecifyUtils.normalizeForSubmit({
                value,
                definition
            })
            : value;

        return collector;
    }, {});
};

module.exports = function useUserInputsSignupDetails({
    formConfig = FormConfig,
    getFieldValue,
    preferencesHandle
}) {

    const fields = useMemo(
        () => (formConfig.managedFieldNames || FormConfig.managedFieldNames).slice(),
        [formConfig]
    );
    const validationFields = useMemo(() => buildValidationFieldNames({
        allFields: fields,
        formConfig
    }), [fields, formConfig]);

    const getSignupDetails = useCallback((formValues = {}) => {

        const details = internals.normalizeSignupDetails({
            details: FormValueUtils.buildFieldValues({
                fields,
                formValues,
                getFieldValue
            }),
            formConfig
        });

        const preferences = preferencesHandle?.getUserPreferences?.();

        return {
            ...internals.omitFinalSubmitOnlyFields(details),
            preferences
        };
    }, [fields, formConfig, getFieldValue, preferencesHandle]);

    return {
        fields,
        validationFields,
        getSignupDetails
    };
};

module.exports.internals = internals;
